import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card } from "../../common/Card";
export default function List() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    try {
      let data = JSON.parse(localStorage.getItem("listResult"));
      setItems(data);
    } catch (error) {
      let data = JSON.parse(localStorage.getItem("listResult"));
      setItems(data);
    }
  }, []);

  const handleBack = () => {
    let url = localStorage.getItem("backurl")
      ? localStorage.getItem("backurl")
      : "/upload/image";
    navigate(url + window.location.search);
  };
  const viewImage = (ImageId) => {
    navigate(`/list/${ImageId}` + window.location.search);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="cardarrow_flex">
          <img
            src="/assets/images/arrowback.svg"
            className="arrow_back"
            alt=""
            onClick={() => handleBack()}
          />
          <div className="card_box_bg">
            <h4>Your Photo(s) </h4>
            <Card items={items} autoOpenLightbox />
          </div>
        </div>
      </div>
    </>
  );
}
